import { RouteConfig } from "vue-router";

const centrosCostos: RouteConfig = {
  path: "/centrosCostos",
  name: "centrosCostos",
  component: () => import(/* webpackChunkName: "centros-costos" */ "@/views/CentrosCostos.vue"),
};

export default centrosCostos;
